<template>
    <section class="container-fluid section-style-top text-center padding-bottom-0">
        <h1 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md">Featured posts</h1>
        <div class="row">
            <a href="" class="col-md card-inside-cont zoom-image">
                <span class="zoom-image-hover"></span>
                <img src="/assets/temp/thumbnail-temp.jpg" alt="">
                <div class="card-info row align-items-end">
                    <span class="col-xs-auto padding-right-left-0">
                        <i class="material-icons white">chat</i>
                    </span>
                    <div class="col row">
                        <span class="white col-12 text-left zoom-image-hover-text-1"><strong>New Gadgets for Travelers 2014</strong></span>
                        <span class="font-sm white col-12 text-left zoom-image-hover-text-2">Articles</span>
                    </div>
                </div>
            </a>
            <a href="" class="col-md card-inside-cont zoom-image">
                <span class="zoom-image-hover"></span>
                <img src="/assets/temp/thumbnail-temp.jpg" class="" alt="">
                <div class="card-info row align-items-end">
                    <span class="col-xs-auto padding-right-left-0">
                        <i class="material-icons white">chat</i>
                    </span>
                    <div class="col row">
                        <span class="white col-12 text-left zoom-image-hover-text-1"><strong>Zoetry Paraiso de la Bonita – Riviera Maya, Mexico</strong></span>
                        <span class="font-sm white col-12 text-left zoom-image-hover-text-2">Press Release</span>
                    </div>
                </div>
            </a>
            <a href="" class="col-md d-sm-none d-lg-inline-block card-inside-cont zoom-image">
                <span class="zoom-image-hover"></span>
                <img src="/assets/temp/thumbnail-temp.jpg" class="" alt="">
                <div class="card-info row align-items-end">
                    <span class="col-xs-auto padding-right-left-0">
                        <i class="material-icons white">chat</i>
                    </span>
                    <div class="col row">
                        <span class="white col-12 text-left zoom-image-hover-text-1"><strong>Viceroy Anguilla</strong></span>
                        <span class="font-sm white col-12 text-left zoom-image-hover-text-2">Travel Advice</span>
                    </div>
                </div>
            </a>
        </div>
    </section>
</template>

<script>
    export default {
        mounted() {

        }
    }
</script>

<style lang="scss" type="text/scss">
    /** Unique Index Styles **/
</style>